import LogoImg from '../../../../assets/img/logo.png';
import Typography from '@mui/material/Typography';
import RoutListMenu from './RoutListMenu';
import Profile from './Profile';
import { Box, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { containsUUID, removeUUIDs } from 'app/helper';
import BackIcon from 'app/components/icons/BackIcon';
import CustomSquareButton from 'app/components/buttons/CustomSquareButton';

const Header = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const theme = useTheme();

  // Get the current path
  const currentPath = useLocation()?.pathname.slice(1);

  // Check for UUID in the current path and remove it if present
  const cleanedPath = containsUUID(currentPath) ? removeUUIDs(currentPath) : currentPath;

  return (
    <div className='sticky top-0 flex justify-between items-center z-30'>
      <div className='flex bg-white items-center gap-2 rounded-md h-[50px] shadow-[4px_4px_10px_0_rgba(0,0,0,0.10)]'>
        <img src={LogoImg} className='w-[148px]' />

        <Box
          className='border-l-2 border-r-2 px-2 flex items-center justify-between gap-3'
          sx={{
            borderColor: theme.palette.primary.main,
          }}
        >
          <RoutListMenu />

          <CustomSquareButton
            onClick={() => navigate(-1)}
            title='Back'
            squareSize={40}
            placement='bottom'
          >
            <BackIcon />
          </CustomSquareButton>
        </Box>

        <Typography
          className='px-3 text-2xl min-w-[130px] flex-grow text-center'
          sx={{
            borderColor: theme.palette.primary.main,
          }}
        >
          {cleanedPath && intl.formatMessage({ id: cleanedPath })}
        </Typography>
      </div>
      <div className='flex-grow'></div>

      <Profile />
    </div>
  );
};

export default Header;
